import { GeckoFeatureModelType } from 'types'
import { SortTableByField } from 'types/geckoFormTypesAndHelpers'

import { GeckoFeature } from './geckoFeature'

export interface FeatureTableOptions {
  type: GeckoFeatureModelType
  title: string
  singularName: string
  fields: string[]
  sortBy?: SortTableByField[]
  disableEditing?: boolean
  tableMessage?: string
}

/**
 * GeckoEditableFeature class is the base class that is used by Asset Model.
 * It is designed to be an abstract class that is extended by other classes that
 * can be edited in the Asset Model Edtior extension
 */
export class GeckoEditableFeature extends GeckoFeature {
  /**
   * Constructor for the base GeckoEditableFeature class. This class should not
   * be instantiated on its own, but should instead be extended
   * @param id
   */
  constructor(id: string) {
    super(id)
    if (this.constructor === GeckoEditableFeature) {
      throw new Error(
        'Abstract Class GeckoEditableFeature is not designed to be instantiated directly'
      )
    }
  }

  /**
   * Required helper function that produces an Asset Model Feature compatible JSON of a GeckoEditableFeature
   */
  public asJSON(): object {
    throw new Error('asJSON function was not implemented on this class!')
  }

  CreateFromJSON(
    componentID: string,
    featureID: string,
    featureJSON: Record<string, unknown>
  ): GeckoEditableFeature {
    throw new Error(
      `CreateFromJSON was not implemented on this class! Provided arguments: ${componentID}, ${featureID}, ${featureJSON}`
    )
  }
}
